import { MarkupOutput } from '../../../integrated-client/models';

export type MarkupEditorModel = MarkupOutput;

export interface IMarkupEditorData {
  editorData?: MarkupEditorModel
  validation?: any
  readyToSave: boolean
}
export class MarkupEditorData implements IMarkupEditorData {

  editorData?: MarkupEditorModel
  validation?: any
  readyToSave: boolean

  constructor() {
    this.readyToSave = false;
  }
}